import type { I18nFn } from 'i18n/types/I18nFn';
import type { ApiOrgSize } from 'modules/listing/orgs/api/types/ApiOrgSize';

type OrgSizeOption = {
  value: ApiOrgSize | '';
  label: string;
  disabled?: boolean;
};

export function ORG_SIZES_EMPLOYEES(i18n: I18nFn): OrgSizeOption[] {
  return [
    {
      value: '',
      label: i18n('Select One'),
      disabled: true,
    },
    {
      value: '1_10',
      label: i18n('1-10 employees'),
    },
    {
      value: '11_25',
      label: i18n('11-25 employees'),
    },
    {
      value: '26_50',
      label: i18n('26-50 employees'),
    },
    {
      value: '51_100',
      label: i18n('51-100 employees'),
    },
    {
      value: '101_250',
      label: i18n('101-250 employees'),
    },
    {
      value: '251_500',
      label: i18n('251-500 employees'),
    },
    {
      value: '501_1000',
      label: i18n('501-1000 employees'),
    },
    {
      value: '1001_PLUS',
      label: i18n('>1000 employees'),
    },
    {
      value: 'NOT_SURE',
      label: i18n("I'm not sure"),
    },
  ];
}

export function ORG_SIZES_MEMBERS(i18n: I18nFn): OrgSizeOption[] {
  return [
    {
      value: '',
      label: i18n('Select One'),
      disabled: true,
    },
    {
      value: '1_10',
      label: i18n('1-10 members'),
    },
    {
      value: '11_25',
      label: i18n('11-25 members'),
    },
    {
      value: '26_50',
      label: i18n('26-50 members'),
    },
    {
      value: '51_100',
      label: i18n('51-100 members'),
    },
    {
      value: '101_250',
      label: i18n('101-250 members'),
    },
    {
      value: '251_500',
      label: i18n('251-500 members'),
    },
    {
      value: '501_1000',
      label: i18n('501-1000 members'),
    },
    {
      value: '1001_PLUS',
      label: i18n('>1000 members'),
    },
    {
      value: 'NOT_SURE',
      label: i18n("I'm not sure"),
    },
  ];
}
